import { render, staticRenderFns } from "./chatItem.vue?vue&type=template&id=0c08da3b&scoped=true&"
import script from "./chatItem.vue?vue&type=script&lang=js&"
export * from "./chatItem.vue?vue&type=script&lang=js&"
import style0 from "./chatItem.vue?vue&type=style&index=0&id=0c08da3b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c08da3b",
  null
  
)

export default component.exports